import { StyledContent } from '@/components/styles';
import { Picture } from '@/components';

const Credo = ({ data, video }) => {
  const { content, image } = data;
  return (
    <>
      {!video && image && Object.keys(image).length > 0 && <Picture {...image} />}
      {video && <video autoplay="autoplay" loop="loop" muted="muted" playsinline="playsinline" src={video}></video>}
      {content && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: content }} dark/>
        </StyledContent.Description>
      )}
    </>
  );
};

export default Credo;
